export default "__VITE_ASSET__DAVm3XxN__"